import { useContext } from 'react';
import { PaymentsChartsDataContext } from '../contexts/PaymentsChartsContext';

export const usePaymentsChartsContext = () => {
    return useContext(PaymentsChartsDataContext);
};
